<template>
  <div>
    <div v-if="$store.state.user.clientID" :key="$root.time">
      <h1 class="main-heading">Freight</h1>
      <SectionNavigator
        :sections="$root.freight.sections"
        :schemas="$root.freight.schemas"
      />
      <router-view />
    </div>
  </div>
</template>

<script>
import SectionNavigator from '../SectionNavigator'
// import routes from '../../router/index'
export default {
  name: 'category-freight',
  props: { sections: String, schemas: Array },
  components: {
    SectionNavigator
  }
}
</script>
